export const COUNTRIES_MAP = {
  dk: 'Denmark',
  fi: 'Finland',
  no: 'Norway',
  se: 'Sweden',
  ax: 'Aaland Islands',
  at: 'Austria',
  br: 'Belgium',
  cz: 'Czech Republic',
  ee: 'Estonia',
  fo: 'Faroe Islands',
  fr: 'France',
  de: 'Germany',
  fl: 'Greenland',
  is: 'Iceland',
  it: 'Italy',
  lv: 'Latvia',
  lt: 'Lithuania',
  nl: 'Netherlands',
  pl: 'Poland',
  sk: 'Slovakia',
  uk: 'United Kingdom',
  ch: 'Switzerland',
  row: 'RestOftheWorld',
};

/**
 * Set of European country codes derived from COUNTRIES_MAP.
 * 'row' (Rest of World) is excluded so only genuine European codes remain.
 * Used to filter GraphHopper geocoding results to European locations only.
 */
export const EUROPEAN_COUNTRY_CODES = new Set(
  Object.keys(COUNTRIES_MAP).filter((code) => code !== 'row'),
);

export const CURRENCIES = {
  dkk: 'Danish krone',
  sek: 'Swedish krona',
  nok: 'Norwegian krone',
  eur: 'Euro',
};

export const FUEL = {
  Diesel: 'Diesel',
  Gasoline: 'Gasoline',
  Electric: 'Electric',
  HVO: 'HVO',
  BIO: 'BIO',
  Train: 'Train',
};

export const RECEIVEDSTATUS = {
  PickupKipp: 'PickUp Kipp',
  HandedOverKipp: 'Handed over Kipp',
  ReceivedAndHandled: 'Received and Handled Terminal',
  ReceivedNotStarted: 'Received not Started Terminal',
  None: 'None',
};

export const TRAFFIC_TYPES = {
  Outbound: 'Outbound',
  Export: 'Export',
  Inbound: 'Inbound',
  Import: 'Import',
} as const;

export type TrafficType = (typeof TRAFFIC_TYPES)[keyof typeof TRAFFIC_TYPES];

export const TABLE_NAMES = {
  Checkpoints: 'checkpoints',
  Customers: 'customers',
  Deviations: 'deviations',
  RouteDeviations: 'routeDeviations',
  CustomerDeviations: 'customerDeviations',
  FixedRoutes: 'fixedRoutes',
  FixedTrafficOverview: 'fixedTrafficOverview',
  PeakPlanning: 'peakPlanning',
  PeakPlanningDebit: 'peakPlanningDebit',
  SporadicRoutes: 'sporadicRoutes',
  Subcontractors: 'subcontractors',
  Terminals: 'terminals',
  TourRouteTemplates: 'tourRouteTemplates',
  TourTemplateOverview: 'tourTemplateOverview',
  TourTemplates: 'tourTemplates',
  TruckFillAndTime: 'truckFillAndTime',
  TFTReadOnly: 'truckFillAndTimeReadOnly',
  ViewSporadicRouteTemplates: 'ViewSporadicRouteTemplates',
  OtherTours: 'OtherTours',
  RemainingGoods: 'RemainingGoods',
  RemainingGoodsReport: 'RemainingGoodsReport',
  RouteLegInReport: 'RouteLegInReport',
  ShipmentList: 'ShipmentList',
  MatchingShipment: 'MatchingShipment',
  ShipmentGrid: 'ShipmentGrid',
  FrontPagePosts: 'FrontPagePosts',
  CustomsTFTRouteGrid: 'CustomsTFTRouteGrid',
  CustomsTFTLegGrid: 'CustomsTFTLegGrid',
  EditableLegLevelGrid: 'EditableLegLevelGrid',
  EditableLoadingListGrid: 'EditableLoadingListGrid',
  LegsList: 'legsLists',
  LegsListCustomSearch: 'legsListCustomSearch',
  NewShipmentLoadingList: 'NewShipmentLoadingList',
  Locations: 'locations',
  Assets: 'assets',
};
export const OVERRIDE_DEPARTMENT_HEADER = 'x-override-department';

export const FIXED_BOX_ORDER: Record<string, number> = {
  Volume: 0,
  'Sorter Start': 1,
  'Sorter End': 2,
  'Interruption total time': 3,
};

export const REQUIRED_FIXED_BOXES = ['Sorter Start', 'Sorter End', 'Volume'];
